jQuery(document).ready(function ($) {
    $("#submit-review").on("click", function (e) {
        e.preventDefault();

        const formData = new FormData();
        const files = $("#review_attachments")[0]?.files || [];

        const isLoggedIn = $("body").hasClass("logged-in");
        const hasSavedAge = $("#age").length === 0; 

        const name = isLoggedIn ? "" : $("#comment_author").val()?.trim();
        const email = isLoggedIn ? "" : $("#comment_author_email").val()?.trim();
        const age = hasSavedAge ? "" : $("#age").val();
        const title = $("#review_title").val()?.trim();
        const review = $("#comment").val()?.trim();
        const rating = $("#rating").val();

        // ✅ Required Fields Validation
        let errors = [];
        if (!isLoggedIn && !name) errors.push("Name is required.");
        if (!hasSavedAge && !age) errors.push("Age is required.");
        if (!title) errors.push("Review title is required.");
        if (!review) errors.push("Review text is required.");
        if (!rating) errors.push("Rating is required.");

        if (errors.length > 0) {
            showReviewMessage(errors.join("<br>"), "red");
            return;
        }

        formData.append("action", "submit_review");
        formData.append("comment_post_ID", $("input[name='comment_post_ID']").val());
        formData.append("rating", rating);
        formData.append("comment_author", name);
        formData.append("comment_author_email", email || ""); // Optional
        formData.append("review_title", title);
        formData.append("comment", review);
        formData.append("age", age);
        formData.append("security", $("#review_security").val()); // Hidden security field

        $.each(files, function (index, file) {
            formData.append("review_attachments[]", file);
        });

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function () {
                $("#submit-review").prop("disabled", true).find(".spinner-border").show();
            },
            success: function (response) {
                if (response.success) {
                    showReviewMessage(response.data.message, "green");
                    $(".comment-form-fields input, .comment-form-fields textarea, .comment-form-fields select").val("");
                } else {
                    showReviewMessage(response.data.message, "red");
                }
            },
            error: function () {
                showReviewMessage("Error submitting review.", "red");
            },
            complete: function () {
                $("#submit-review").prop("disabled", false).find(".spinner-border").hide();
            },
        });
    });

    function showReviewMessage(message, color) {
        $("#review-message").html(`<span style="color: ${color};">${message}</span>`).fadeIn();
    }

    function loadReviews(page = 1) {
        let productId = $('.custom-reviews').data('product-id');

        $.ajax({
            url: wc_add_to_cart_params.ajax_url,
            type: 'POST',
            data: {
                action: 'load_reviews',
                product_id: productId,
                page: page,
            },
            beforeSend: function () {
                $('.review-pagination').addClass('loading'); 
            },
            success: function (response) {
                if (response.success) {
                    $('.product-reviews__list').fadeOut(100, function() {
                        $(this).html(response.data.html).fadeIn(100);
                    });

                    $('.custom-reviews-pagination').html(response.data.pagination);
                    $('.pagination-link').removeClass('active');
                    $('.pagination-link[data-page="' + page + '"]').addClass('active');
                }
            },
            error: function () {
                $('.review-pagination').html('<span style="color: red;">Error loading reviews.</span>');
            },
            complete: function () {
                $('.review-pagination').removeClass('loading'); 
            }
        });
    }

    $(document).on('click', '.review-pagination .pagination-link', function (e) {
        e.preventDefault();
        let page = $(this).data('page') || 1;
        loadReviews(page);
    });
});